(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodPreventDefault', sodPreventDefault);

    function sodPreventDefault() {
        return {
            restrict: 'A',
            link: link,
            controller: sodPreventDefaultCtrl,
            controllerAs: 'vm',
            bindToController: true
        };

        function link(scope, elem) {
            elem.on('click', function(e) {
                e.preventDefault();
            });
        }
    }

    function sodPreventDefaultCtrl($location, $document) {
        var vm = this;
        this.$onInit = function() {
            vm.clickHref = clickHref;
        }

        function clickHref(href) {
            var pathInfo = href.split('?');
            var searchInfo = {};

            if (pathInfo.length > 1) {
                var searchInfoArr = pathInfo[1].split('&');
                searchInfo = searchInfoArr.reduce(function(result, _info) {
                    var _info_splited = _info.split('=');
                    result[_info_splited[0]] = _info_splited[1] || true;
                    return result;
                }, searchInfo);
            }

            $location.path(pathInfo[0]).search(searchInfo);
            $document.focus();
        }
    }
})();